var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "LessonEntityDetails__Component" },
    [
      _c("FieldInlineText", {
        attrs: { label: "שם קופון" },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.name,
          callback: function ($$v) {
            _vm.$set(_vm.model, "name", $$v)
          },
          expression: "model.name",
        },
      }),
      _c("FieldInlineText", {
        attrs: { label: "קוד קופון" },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.code,
          callback: function ($$v) {
            _vm.$set(_vm.model, "code", $$v)
          },
          expression: "model.code",
        },
      }),
      _c("FieldInlineText", {
        attrs: { type: "number", label: "הנחה בשקלים" },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.discountAmount,
          callback: function ($$v) {
            _vm.$set(_vm.model, "discountAmount", $$v)
          },
          expression: "model.discountAmount",
        },
      }),
      _c("FieldInlineText", {
        attrs: { type: "number", label: "אחוז הנחה" },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.discountPercentage,
          callback: function ($$v) {
            _vm.$set(_vm.model, "discountPercentage", $$v)
          },
          expression: "model.discountPercentage",
        },
      }),
      _c("FieldInlineDateTime", {
        attrs: {
          label: "עד תאריך",
          "hide-hover": true,
          position: "is-bottom-left",
        },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.expirationDate,
          callback: function ($$v) {
            _vm.$set(_vm.model, "expirationDate", $$v)
          },
          expression: "model.expirationDate",
        },
      }),
      _c("FieldInlineText", {
        attrs: { type: "number", label: "מלאי" },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.remainingUses,
          callback: function ($$v) {
            _vm.$set(_vm.model, "remainingUses", $$v)
          },
          expression: "model.remainingUses",
        },
      }),
      _c(
        "div",
        { staticClass: "checkbox-container" },
        [
          _c(
            "b-switch",
            {
              staticClass: "ltr",
              on: { input: _vm.onChange },
              model: {
                value: _vm.model.status,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "status", $$v)
                },
                expression: "model.status",
              },
            },
            [_vm._v(_vm._s(_vm.model.status ? "פעיל" : "לא פעיל"))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }